// SponsoredBy returns info regarding the sponsorship of the product or the content
export const AdvertisementService_SponsorshipInfoLazy = () =>
  import("./service.grpc").then((m) => m.AdvertisementService_SponsorshipInfo);
AdvertisementService_SponsorshipInfoLazy.method =
  "aysa_api.services.advertisement.AdvertisementService/SponsorshipInfo" as const;

// GetSponsoredSections returns sponsored sections for a given target type, e.g. search suggestions.
export const AdvertisementService_GetSponsoredSectionsLazy = () =>
  import("./service.grpc").then(
    (m) => m.AdvertisementService_GetSponsoredSections
  );
AdvertisementService_GetSponsoredSectionsLazy.method =
  "aysa_api.services.advertisement.AdvertisementService/GetSponsoredSections" as const;
